import React, { useState } from 'react';

const TTMatrix = () => {
  // Initial matrix data
  const initialMatrix = [
    ['Fixed 1', 'Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5', 'Item 6'], // Monday
    ['Fixed 1', 'Item 7', 'Item 8', 'Item 9', 'Item 10', 'Item 11', 'Item 12'], // Tuesday
    ['Fixed 1', 'Item 13', 'Item 14', 'Item 15', 'Item 16', 'Item 17', 'Item 18'], // Wednesday
    ['Fixed 1', 'Item 19', 'Item 20', 'Item 21', 'Item 22', 'Item 23', 'Item 24'], // Thursday
    ['Fixed 1', 'Item 25', 'Item 26', 'Item 27', 'Item 28', 'Item 29', 'Item 30'], // Friday
  ];

  // State for the matrix
  const [matrix, setMatrix] = useState(initialMatrix);

  // Shuffle function
  const shuffleMatrix = () => {
    const shuffledMatrix = matrix.map((row) => {
      const [fixed, ...shufflable] = row;
      // Shuffle the rest of the row (excluding the first item)
      for (let i = shufflable.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shufflable[i], shufflable[j]] = [shufflable[j], shufflable[i]];
      }
      return [fixed, ...shufflable];
    });

    setMatrix(shuffledMatrix);
  };

  return (
    <div style={{ padding: '20px' }}>
      <table border="1" style={{ borderCollapse: 'collapse', width: '100%' }}>
        <thead>
          <tr>
            <th>Days/Periods</th>
            {Array.from({ length: 7 }, (_, i) => (
              <th key={i}>Period {i + 1}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {matrix.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td>{['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'][rowIndex]}</td>
              {row.map((item, colIndex) => (
                <td key={colIndex}>{item}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <button onClick={shuffleMatrix} style={{ marginTop: '20px' }}>
        Shuffle
      </button>
    </div>
  );
};



export default TTMatrix
